<script>
import {auth} from '../firebase'
import axios from 'axios'
import { getAuth, RecaptchaVerifier, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { sessionData } from '../stores.js'
import {signInWithGoogle} from '../auth'
import {getUserData} from '../userdata'
import {makeOrder} from '../payments'
import Login from "./Login.svelte"
import Tailwindcss from '../Tailwind.svelte';

</script>
<Tailwindcss/>
<div
      id="recaptcha-container"
 ></div>



<button class="bg-purple-800" on:click={makeOrder}>make paypal order</button>


<h2>Home component</h2>

<p>
    This sample shows how to set up the router with minimum functionality. <br/>
    The route definition object contains a number of routes (including some with parameters and a catch-all at the end).<br/>
    The links below allow navigating between pages.
</p>

<p>This is the Home component, which contains markup only.</p>


<iframe src="demo-page.html" name="myFrame" title="myFrame"></iframe>
<p><a href="paypal.com" target="myFrame">Open paypal</a></p>


<p><em>Hint:</em> Try navigating with the links below, then use your browser's back and forward buttons.</p>
